var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResellpartners(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4664 12.4753L16.2982 14.6434C15.5494 15.392 14.534 15.8125 13.4752 15.8125C12.4164 15.8125 11.401 15.392 10.6522 14.6434L10.4805 14.4717L15.4008 9.55141C16.7247 8.22789 18.52 7.48437 20.392 7.48438C22.264 7.48437 24.0593 8.22789 25.3832 9.55141V9.55141C26.4949 10.6633 27.2038 12.1143 27.3975 13.6747C27.5911 15.235 27.2585 16.8153 26.4523 18.1652",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7288 15.7358L23.3355 19.3425C23.8969 19.9041 24.2123 20.6656 24.2123 21.4597C24.2123 22.2538 23.8969 23.0154 23.3355 23.577L21.7024 25.2101C21.1462 25.7664 20.4859 26.2077 19.7591 26.5087C19.0324 26.8098 18.2535 26.9647 17.4668 26.9647C16.6802 26.9647 15.9013 26.8098 15.1745 26.5087C14.4478 26.2077 13.7875 25.7664 13.2313 25.2101L7.55532 19.5341C6.2318 18.2103 5.48828 16.4149 5.48828 14.5429C5.48828 12.6709 6.2318 10.8756 7.55532 9.55173V9.55173C8.86026 8.24314 10.6277 7.50054 12.4756 7.48438",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.849 24.0628L18.9648 20.1797",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9752 26.4166L16.3516 22.793",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResellpartners);
export default __webpack_public_path__ + "static/media/Resellpartners.f818048bc96b1856a3cca3a99e5d357d.svg";
export { ForwardRef as ReactComponent };